import { Icon } from "../icon/icon.tsx";

import type { LucideIcon } from "lucide-react";
import type { ReactElement, ReactNode } from "react";

export interface EmptyStateProps {
  readonly icon: LucideIcon;
  readonly title: string;
  readonly hint: string;
  readonly action?: ReactNode;
}

export const EmptyState = ({ icon, title, hint, action }: EmptyStateProps): ReactElement => (
  <div className="flex flex-col items-center gap-3 px-6 py-12 text-center">
    <span className="text-ink-3">
      <Icon icon={icon} size={32} />
    </span>
    <div className="flex max-w-80 flex-col gap-1">
      <p className="text-title font-semibold text-ink">{title}</p>
      <p className="text-body text-ink-2">{hint}</p>
    </div>
    {action !== undefined && <div className="pt-2">{action}</div>}
  </div>
);
